<template>
  <div>
    <div class='h-dialogContainer'>
      <div class='row h-row-inputBox'>
        <div class='col-sm-4 h-col-inputBox'>
          <div class='h-inputLit'>1:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" :placeholder='$t("TS.ts_xAxis")' v-model="xAxis1"><span class="input-group-addon">ms</span>
          </div>
        </div>
        <div class='col-sm-4 h-col-inputBox'>
          <div class='h-inputLit'>2:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" :placeholder='$t("TS.ts_xAxis")' v-model="xAxis2"><span class="input-group-addon">ms</span>
          </div>
        </div>
        <div class='col-sm-4 h-col-inputBox'>
          <div class='h-inputLit'>3:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" :placeholder='$t("TS.ts_xAxis")' v-model="xAxis3"><span class="input-group-addon">ms</span>
          </div>
        </div>
        <div class='col-sm-4 h-col-inputBox'>
          <div class='h-inputLit'>4:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" :placeholder='$t("TS.ts_xAxis")' v-model="xAxis4"><span class="input-group-addon">ms</span>
          </div>
        </div>
        <div class='col-sm-4 h-col-inputBox'>
          <div class='h-inputLit'>5:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" :placeholder='$t("TS.ts_xAxis")' v-model="xAxis5"><span class="input-group-addon">ms</span>
          </div>
        </div>
        <div class='col-sm-4 h-col-inputBox'>
          <div class='h-inputLit'>6:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" :placeholder='$t("TS.ts_xAxis")' v-model="xAxis6"><span class="input-group-addon">ms</span>
          </div>
        </div>
        <div class='col-sm-4 h-col-inputBox'>
          <div class='h-inputLit'>7:</div>
          <div class="input-group">
          <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" :placeholder='$t("TS.ts_xAxis")' v-model="xAxis7"><span class="input-group-addon">ms</span>
          </div>
        </div>
        <div class='col-sm-4 h-col-inputBox'>
          <div class='h-inputLit'>8:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" :placeholder='$t("TS.ts_xAxis")' v-model="xAxis8"><span class="input-group-addon">ms</span>
          </div>
        </div>
        <div class='col-sm-4 h-col-inputBox'>
          <div class='h-inputLit'>9:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" :placeholder='$t("TS.ts_xAxis")' v-model="xAxis9"><span class="input-group-addon">ms</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import Global from '../Global';
import { EventBus } from '../../../plugins/eventBus';

Vue.use(TextBoxPlugin);

export default {
  name: 'ConfigCallSetUpTimeRangeDialog',
  data() {
    return {
      olapUrl: Global.olapUrl,
      xAxis1: '',
      xAxis2: '',
      xAxis3: '',
      xAxis4: '',
      xAxis5: '',
      xAxis6: '',
      xAxis7: '',
      xAxis8: '',
      xAxis9: ''
    };
  },
  methods: {
    getSubmitData(neId) {
      if (neId === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.selectNeIDIsNull') })
        return;
      }
      const numbers9 = [];
      numbers9.push(this.xAxis1); numbers9.push(this.xAxis2); numbers9.push(this.xAxis3);
      numbers9.push(this.xAxis4); numbers9.push(this.xAxis5); numbers9.push(this.xAxis6);
      numbers9.push(this.xAxis7); numbers9.push(this.xAxis8); numbers9.push(this.xAxis9);
      const check = this.range9Validate(numbers9);
      if (!check) {
        return '';
      }
      return {
        xAxis1: this.xAxis1,
        xAxis2: this.xAxis2,
        xAxis3: this.xAxis3,
        xAxis4: this.xAxis4,
        xAxis5: this.xAxis5,
        xAxis6: this.xAxis6,
        xAxis7: this.xAxis7,
        xAxis8: this.xAxis8,
        xAxis9: this.xAxis9
      };
    },
    range9Validate(aTimeRange) {
      let num1;
      let num2;// num1前一个数,num2后一个数
      if (aTimeRange && aTimeRange.length > 2) {
        while (!num1 && aTimeRange.length > 0) {
          num1 = aTimeRange.pop();
        }
        if (aTimeRange.length === 0) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.ts_chart_atleast_two_numbers') })
          return false;
        }
        if (Number(num1) <= 0) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.ts_chart_firstNumber_bigerthan0') })
          return false;
        }
        if (!(/(^[1-9]\d*$)/.test(num1))) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.ts_chart_xAxis_positive_integer') })
          return false;
        }
        while (aTimeRange.length > 0) {
          num2 = num1;
          num1 = aTimeRange.pop();
          if (isNaN(num1) || isNaN(num2)) {
            EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.ts_chart_illegal_number') })
            return false;
          } else if (Number(num1) <= 0) {
            EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.ts_chart_firstNumber_bigerthan0') })
            return false;
          } else {
            if (!(/(^[1-9]\d*$)/.test(num1))) {
              EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.ts_chart_xAxis_positive_integer') })
              return false;
            }
          }
          if (!num1 && aTimeRange.length > 0) {
            EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.ts_number_not_null') })
            return false;
          } else if (Number(num1) >= Number(num2)) {
            EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.ts_back_must_larger_than_pre') })
            return false;
          }
        }
        return true;
      }
    },
    getXasixValue(neId) {
      const url = `${this.olapUrl}/lte/ems/olap/voice/axisFillData.html?neId=${neId}`;
      this.$axios.get(url).then((response) => {
        if (response && response.status === 200 && response.data) {
          this.xAxis1 = (response.data.xAxis1 === 'undefined') ? '' : response.data.xAxis1;
          this.xAxis2 = (response.data.xAxis2 === 'undefined') ? '' : response.data.xAxis2;
          this.xAxis3 = (response.data.xAxis3 === 'undefined') ? '' : response.data.xAxis3;
          this.xAxis4 = (response.data.xAxis4 === 'undefined') ? '' : response.data.xAxis4;
          this.xAxis5 = (response.data.xAxis5 === 'undefined') ? '' : response.data.xAxis5;
          this.xAxis6 = (response.data.xAxis6 === 'undefined') ? '' : response.data.xAxis6;
          this.xAxis7 = (response.data.xAxis7 === 'undefined') ? '' : response.data.xAxis7;
          this.xAxis8 = (response.data.xAxis8 === 'undefined') ? '' : response.data.xAxis8;
          this.xAxis9 = (response.data.xAxis9 === 'undefined') ? '' : response.data.xAxis9;
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
